// The light/dark switch in the header, shared by every page. The choice is
// remembered; without one the page follows the system setting.
import type { InteractiveIcon } from '../dist/core/index.js';

const KEY = 'ii-theme';

/**
 * Applies the remembered theme and wires up the header switch. Pages call
 * this rather than importing the module for its effect: package.json marks
 * modules side-effect free, so a bare import would be dropped.
 */
export function initTheme(): void {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(KEY);
  } catch {
    // Storage blocked: follow the system setting.
  }
  if (stored === 'dark' || stored === 'light') document.documentElement.dataset.theme = stored;

  const icon = document.querySelector<InteractiveIcon>('#theme-toggle ii-theme');
  if (!icon) return;
  icon.toggleAttribute('active', stored ? stored === 'dark' : matchMedia('(prefers-color-scheme: dark)').matches);
  icon.addEventListener('ii-change', (e) => {
    const theme = e.detail.active ? 'dark' : 'light';
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      // Private mode: the choice lasts for this page.
    }
  });
}
